module.exports = __webpack_public_path__ + "static/media/bolon-design-3.ff501671.jpg";